<template>
  <div class="asc-user-index">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AscUserIndex',
}
</script>
